import {
  type PickNOptionLabelSource,
  type PickTimeOption,
  getPickNOptionDisplayName,
  getPickTimeDisplayName,
} from '@/helpers/flowOptionLabel'

/** `<display name> (<resolver_id>)` for GA4 and `bundle_step`. */
export function formatPickNOptionValue(
  optionResolverId: string,
  options: PickNOptionLabelSource[] | undefined,
): string {
  const option = options?.find(({ resolver_id }) => resolver_id === optionResolverId)

  if (!option) {
    return optionResolverId
  }

  const displayName = getPickNOptionDisplayName(option)
  if (!displayName) {
    return optionResolverId
  }

  return `${displayName} (${optionResolverId})`
}

/** `pick_n` option label plus `: selected` / `: unselected`. */
export function formatPickNSelectionValue(
  optionResolverId: string,
  options: PickNOptionLabelSource[] | undefined,
  isSelected: boolean,
): string {
  return `${formatPickNOptionValue(optionResolverId, options)}: ${isSelected ? 'selected' : 'unselected'}`
}

/** `pick_variants` row label with resulting quantity, e.g. `Adult: 2`. */
export function formatVariantQuantityValue(variant: string, quantity: number): string {
  return `${variant}: ${quantity}`
}

/** `<display time> (<session id>)` for `bundle_step`. */
export function formatPickTimeValue(timeId: string, times: PickTimeOption[] | undefined): string {
  const time = times?.find(({ id }) => id === timeId)

  if (!time) {
    return timeId
  }

  return `${getPickTimeDisplayName(time)} (${timeId})`
}
